import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import ConverterLayout from './ConverterLayout';
import { Alert, Box, Typography } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';

function JsonToCsv() {
  const [json, setJson] = useState(`[
  {
    "id": 1,
    "name": "Item A",
    "value": 100
  },
  {
    "id": 2,
    "name": "Item B",
    "value": 200
  }
]`);
  const [csv, setCsv] = useState('');
  const [error, setError] = useState('');

  const handleConvert = () => {
    setError('');
    if (!json.trim()) {
      setCsv('');
      return;
    }

    try {
      const parsedJson = JSON.parse(json);
      const result = Papa.unparse(parsedJson);
      setCsv(result);
    } catch (e) {
      setError(e.message);
      setCsv('');
    }
  };

  const handleSwap = () => {
    const tempCsv = csv;
    setCsv(json); // Not a direct conversion, just swapping content for a new start
    setJson(tempCsv);
    setError('');
  };

  const handleClear = () => {
    setJson('');
    setCsv('');
    setError('');
  };

  // Auto-convert sample data on load
  useEffect(() => {
    handleConvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="JSON to CSV Converter | Free Online Tool | UmbrellaCo"
        description="Instantly convert JSON objects and arrays into comma-separated values (CSV). Auto-detects columns and handles nested JSON properties for easy spreadsheet export."
        keywords="json to csv, convert json to csv, json to csv converter online, json to excel, online json tools"
        url="/json-tools/json-to-csv"
        jsonLd={createSoftwareAppSchema(
          'JSON to CSV Converter',
          'Instantly convert JSON objects and arrays into comma-separated values (CSV).',
          'https://umbrellaco.in/json-tools/json-to-csv',
          ['JSON Parsing', 'CSV Export', 'Automatic Column Detection']
        )}
      />
      {error && <Alert severity="error" sx={{ mx: 2, mb: 1 }}>{error}</Alert>}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <ConverterLayout
          title="JSON to CSV Converter"
          description="Convert your JSON arrays into comma-separated values (CSV) suitable for Excel and Google Sheets."
        leftTitle="JSON"
        rightTitle="CSV"
        leftLanguage="json"
        rightLanguage="plaintext"
        leftValue={json}
        setLeftValue={setJson}
        rightValue={csv}
        onConvert={handleConvert}
        onSwap={handleSwap}
        onClear={handleClear}
        />
      </Box>
    </Box>
  );
}

export default JsonToCsv;